import { format, isDate, isValid, parse } from 'date-fns'
import nlLocale from 'date-fns/locale/nl'

const capitalize = (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

const date = (value) => {
  if (!value) {
    return
  }
  if (isDate(value)) {
    return format(value, 'dd MMMM yyyy', { locale: 'nl' })
  }
  else {
    const date = parse(value, 'dd-MM-yyyy', new Date())
    if (isValid(date)) {
      return format(date, 'dd MMMM yyyy', { locale: nlLocale })
    }
    else {
      let date = value.split(' ')
      date = date[0].split('-')
      if (date.length === 3) {
        const toFormat = new Date(date[0], date[1] - 1, date[2])
        return format(toFormat, 'dd MMMM yyyy', { locale: nlLocale })
      }
      return value
    }
  }
}

const uppercase = (value) => {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
}

const toHuman = (value) => {
  if (!value) return ''
  let parts = value.split('_')
  for (let i = 0; i < parts.length; i++) {
    parts[i] = parts[i].substr(0, 1).toUpperCase() + parts[i].substr(1)
  }

  parts = parts.join(' ')

  return parts
}

const lowercase = (value) => {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
}
const underscore = (value) => {
  if (!value) return ''
  value = value.toString()
  return value.replace(/_/g, ' ')
}

export {
  capitalize, uppercase, lowercase, underscore, toHuman, date
}
